var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68525 9.37499V8L11.916 9.99999L7.68525 12V10.625H1.91602V9.37499H7.68525Z",
    fill: "#C691FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.875V16.5C5 17.0523 5.44771 17.5 6 17.5H15C15.5523 17.5 16 17.0523 16 16.5V3.5C16 2.94772 15.5523 2.5 15 2.5H6C5.44772 2.5 5 2.94772 5 3.5V8.125",
    stroke: "#C691FB",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/log-in.d461c985397420b9a19a6a7453f24188.svg";
export { ForwardRef as ReactComponent };